import script from "./CoreUiChatHistoryMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessage.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessage.vue?vue&type=style&index=0&id=7b51e480&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b51e480"]])

export default __exports__